import { Loading } from '../loading';
import { Copy } from '../copy';
import { styles } from '../../constants';
import { isActive } from './shared';

export const UrlsList = ({ urls, job }) => (
  <div>
    <div style={styles.stickyHeader}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <div>
          <b>{urls.length}</b> URLs found
        </div>
        {urls.length > 0 && <Copy value={urls.join('\n')} onlyCheck />}
        {isActive(job) && <Loading size="xs" />}
      </div>
    </div>

    <div>
      {urls.map((it, idx) => (
        <div key={idx}>{it}</div>
      ))}
    </div>
  </div>
);
